export default __webpack_public_path__ + "static/media/insta.b85f7609.svg";